import isNil from "lodash/isNil";
import pickBy from "lodash/pickBy";
import { ApiWrapper } from "../types/main";
import { apiCall, http } from "./http";

export async function getServiceTags({
    projectId,
    isHr,
    filial,
}: {
    projectId: string,
    isHr: boolean,
    filial: string | null,
}): Promise<ApiWrapper<any>> {
    const url = `GCB2/tagging`;
    const params: any = pickBy(
        { projectId, isHr, filial },
        (v, k) => {
            if (isNil(v)) {
                return false;
            }
            return true;
        },
    );
    const res = apiCall<any>(() => http.get(url.toString(), { searchParams: params }));
    return res;
}
export async function updateServiceTags({
    projectId,
    isHr,
    services,
    filial,
}: {
    projectId: string
    isHr: boolean
    services: any[]
    filial: string | null,
}): Promise<ApiWrapper<any>> {
    const url = `GCB2/tagging`;
    const res = apiCall<any>(() => http.post(url.toString(), { json:
        pickBy(
            { projectId, isHr, services, filial},
            (v, k) => {
                if (isNil(v)) {
                    return false;
                }
                return true;
            },
        )}));
    return res;
}
